import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import { function_CON_OperacionesParaImportar_Insertar, function_CON_OperacionesParaImportar_Leer, function_CON_OperacionesParaImportar_Modificar } from "neftis7_apicaller/src/funciones/CONT/CON_OperacionesParaImportar";
import { CheckBox, DateBox, NumberBox, RadioGroup, TextBox } from "devextreme-react";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { FormateoFechaPara_yyyyMMdd, FormateoFechaPara_yyyyMMdd_HHmmss } from "neftis7_apicaller/src/funciones/Varios";
import ComboAbmConCuentasFinancieras from "../../Componentes/Compuestos/Combos/ComboAbmConCuentasFinancieras";
import ComboAbmConSubCentrosCosto from "../../Componentes/Compuestos/Combos/ComboAbmConSubCentrosCosto";
import LVNumberBoxDocumento from "../../Componentes/Compuestos/Complejos/LVNumberBoxDocumento";
import ComboVenDocsVentaTipos from "../../Componentes/Compuestos/Combos/ComboVenDocsVentaTipos";
import ComboAbmArtArticulos from "../../Componentes/Compuestos/Combos/ComboAbmArtArticulos";
import ComboAbmEexClientes from "../../Componentes/Compuestos/Combos/ComboAbmEexClientes";
import ComboAbmEexProveedores from "../../Componentes/Compuestos/Combos/ComboAbmEexProveedores";
import { function_CON_Cheques_Generar_JSON, function_CON_Cheques_Insertar, function_CON_Cheques_Leer } from "neftis7_apicaller/src/funciones/CONT/CON_Cheques";

export const CON_Cheques_ModificacionCreacion = (props) => {

  let Codigo = useParams()

  const [loading, setLoading] = useState(true);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [fechaEmision, setFechaEmision] = useState(new Date());
  const [fechaPagoCompromiso, setFechaPagoCompromiso] = useState(new Date());
  const [numero, setNumero] = useState("")
  const [banco, setBanco] = useState("")
  const [cuenta, setCuenta] = useState("")
  const [cuit, setCUIT] = useState("")
  const [direccion, setDireccion] = useState("")
  const [razonSocial, setRazonSocial] = useState("")
  const [domicilioPago, setDomicilioPago] = useState("")
  const [razonSocial_Origen, setRazonSocial_Origen] = useState("")
  const [importe, setImporte] = useState(0);

  const onClickAgregar = async () => {
    try {
      if (importe <= 0) {
        alert("El Importe debe ser mayor a cero.");
        return;
      }

      const JSON = await function_CON_Cheques_Generar_JSON(localStorage.getItem("CodigoCompania"), null, null, null, null, numero,
        FormateoFechaPara_yyyyMMdd(fechaEmision), FormateoFechaPara_yyyyMMdd(fechaPagoCompromiso), null, null, null, banco, importe, 1110, 0, 0, cuenta, cuit, direccion, razonSocial,
        domicilioPago, razonSocial_Origen, null, null, null)

      if (Codigo.Codigo === "--NUEVO--") {
        const resultIdOperacion = await function_CON_Cheques_Insertar(JSON)

        alert("Se ha creado el Cheque Nº " + resultIdOperacion.data.codigoGenerado)
      } else {
        alert("No se pueden modificar Cheques por el momento")
      }
    } catch (error) {
      alert(error);
    } finally {

    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")
        } else {
          setTituloBoton("ACTUALIZAR ID " + Codigo.Codigo)
          setAccionBoton("ACTUALIZAR ID " + Codigo.Codigo)

          let datosCheque = await function_CON_Cheques_Leer(Codigo.Codigo)

          if (datosCheque && datosCheque.data) {


            setFechaEmision(datosCheque.data[0].FechaEmision)
            setFechaPagoCompromiso(datosCheque.data[0].FechaPagoCompromiso)
            setNumero(datosCheque.data[0].Numero)
            setBanco(datosCheque.data[0].Banco)
            setCuenta(datosCheque.data[0].Cuenta)
            setCUIT(datosCheque.data[0].CUIT)
            setDireccion(datosCheque.data[0].Direccion)
            setRazonSocial(datosCheque.data[0].RazonSocial)
            setDomicilioPago(datosCheque.data[0].DomicilioPago)
            setRazonSocial_Origen(datosCheque.data[0].RazonSocial_Origen)
            setImporte(datosCheque.data[0].Importe)
          }
        }
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, []);

  return (
    <PaginaCarga
      Titulo="CHEQUES"
    >
      <div className="LV-GroupBox-div"
        style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center' }}
      >
        <div className="LV-FlexContainer" style={{ gap: 42, marginBottom: 10 }}>
          Fecha Emisión:
          <DateBox width={140} displayFormat="dd/MM/yyyy"
            value={fechaEmision}
            style={{ marginLeft: '5px', marginRight: '20px' }}
            onValueChanged={(e) => setFechaEmision(e.value)} />

          Fecha Pago Compromiso:
          <DateBox width={140} displayFormat="dd/MM/yyyy"
            value={fechaPagoCompromiso}
            style={{ marginLeft: '5px', marginRight: '20px' }}
            onValueChanged={(e) => setFechaPagoCompromiso(e.value)} />

          <TextBox width={'300px'} label="Número" value={numero} onValueChanged={(e) => setNumero(e.value)} />

          <NumberBox width={'300px'} label="Importe" value={importe} onValueChanged={(e) => setImporte(e.value)} />

          <TextBox width={'100%'} label="Banco" value={banco} onValueChanged={(e) => setBanco(e.value)} />
        </div>

        <div className="LV-FlexContainer" style={{ gap: 42, marginBottom: 10 }}>
          <TextBox width={'100%'} label="Cuenta" value={cuenta} onValueChanged={(e) => setCuenta(e.value)} />
          <TextBox width={'100%'} label="C.U.I.T." value={cuit} onValueChanged={(e) => setCUIT(e.value)} />          
        </div>

        <div className="LV-FlexContainer" style={{ gap: 42, marginBottom: 10 }}>
          <TextBox width={'100%'} label="Dirección" value={direccion} onValueChanged={(e) => setDireccion(e.value)} />
          <TextBox width={'100%'} label="Razón Social" value={razonSocial} onValueChanged={(e) => setRazonSocial(e.value)} />
          <TextBox width={'100%'} label="Domicilio de Pago" value={domicilioPago} onValueChanged={(e) => setDomicilioPago(e.value)} />
          <TextBox width={'100%'} label="Razón Social de Origen" value={razonSocial_Origen} onValueChanged={(e) => setRazonSocial_Origen(e.value)} />
        </div>

        <LVButtonAccion
          Texto="GUARDAR"
          Ancho={"100%"}
          onClick={onClickAgregar}
        />
      </div>
    </PaginaCarga>
  );
}
